import { useState } from 'react';
import { useSelector } from 'react-redux';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description
 * Hook-based component to manage SIO page states.
 * Handles development mode, permissions, modal visibility,
 * and selected items for SIO operations.
 */

const SiosApp = () => {
    // Development mode and user permissions from Redux
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    // Modal visibility states
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [createModalShow, setCreateModalShow] = useState(false);

    // Selected items in the table
    const [selectedList, setSelectedList] = useState([]);

    // Expose states and setters
    return {
        DEV,
        permission,
        deleteModalShow,
        setDeleteModalShow,
        createModalShow,
        setCreateModalShow,
        selectedList,
        setSelectedList
    };
};

export default SiosApp;
